export default __webpack_public_path__ + "static/1-2a544f5d106c6711e1eb013ef781b8ab.png";